import { toast } from "react-toastify";
import { useAppDispatch } from "../store";
import { SetNotifyMessage } from "../store/slices/applicationData";
import useConfirm from "../hooks/useConfirm";

type AlertColor = 'success' | 'error' | 'warning' | 'info';

function useAppUtils() {
    const dispatch = useAppDispatch();
    const { AppConfirm } = useConfirm();

    const alert = (msg: string, severity: AlertColor = 'success') => {
        toast(msg, { position: toast.POSITION.TOP_CENTER, type: severity,theme: "colored" });
    };

    const confirm = async (msg: string) => {
        // console.log('isConfirmed', msg);
        return await AppConfirm(msg);
    };

    return { alert, confirm };
}

export default useAppUtils;